module.exports = __webpack_public_path__ + "img/empty.072cc543.png";